import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../constants/config';
import { oauthLogin } from '../../actions/auth';
import { toastError } from '../../actions/toast';
import AppleLogin from 'react-apple-login'
import jwt from 'jsonwebtoken'


const AppleAuthLogin = (props) => {
    const dispatch = useDispatch();
    const { history } = props;
    const clientId = config && config.oauth && config.oauth.apple && config.oauth.apple.CLIENT_ID
        ? config.oauth.apple.CLIENT_ID : null;
    const redirectUri = config && config.oauth && config.oauth.apple && config.oauth.apple.REDIRECT_URI
        ? config.oauth.apple.REDIRECT_URI : null;
    const scopes = config && config.oauth && config.oauth.apple && config.oauth.apple.SCOPES
        ? config.oauth.apple.SCOPES : null;

    const [isSignedIn, setIsSignedIn] = useState(false);

    const isRequest = useSelector((state) => state.auth.isRequest)

    const appleResponse = (response) => {
        setIsSignedIn(true);
        if (response && response.authorization && response.authorization.id_token) {
            const idToken = jwt.decode(response.authorization.id_token);
            if (idToken.email_verified && idToken.email) {
                const params = {
                    login: idToken.email,
                    provider: 3
                }
                const cb = () => {
                    setIsSignedIn(false);
                }
                dispatch(oauthLogin(params, history, cb));
                return;
            }
            setIsSignedIn(false);
            dispatch(toastError('Please contact Admin.'));
            return;
        }
        if (response && response.error && response.error.error) {
            setIsSignedIn(false);
            dispatch(toastError(response.error.error));
        }
    }

    return (
        <div className={`apple-login-btn ${isRequest && "disabled"}`}>
            {(clientId && redirectUri) && <AppleLogin
                clientId={clientId}
                redirectURI={redirectUri}
                usePopup={true}
                callback={appleResponse}
                scope={scopes}
                responseMode="query"
                render={renderProps => (
                    <button className='customBtn'
                        onClick={renderProps.onClick}
                        disabled={isRequest}
                    >
                        <i className="fa fa-apple"></i>
                        <span className='buttonText'>{isSignedIn ?  "Authenticating..." : "Sign in with Apple"}</span>
                    </button>
                )}
            />}

        </div>
    )
}

export default AppleAuthLogin;